import Plyr from "plyr";

class VimeoPlyrPlayer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.player = new Plyr(this.querySelector("[data-player]"));
  }

  disconnectedCallback() {}
}

if (!customElements.get("vimeo-plyr-player")) {
  customElements.define("vimeo-plyr-player", VimeoPlyrPlayer);
}
